import numbro from 'numbro';


export const getCompetitionProgressBars = (userRecord, seasonMilestone, t) => {
    var result = [];
    if(!userRecord) {
        return result;
    }

    var properties = ['actions', 'activities', 'steps', 'glasses', 'duration', 'floors', 'photos', 'points', 'resources'];

    for(var i = 0; i < properties.length; i++) {
        var property = properties[i];
        if(seasonMilestone && seasonMilestone[property]!==null) {
            let a = userRecord[property] || 0;
            let b = seasonMilestone[property];
            let percent = Math.floor(100.0*(a / b));
            if(property==='duration') {
                a = a / 60;
                b = b / 60;
            }
            var formatOpts = {mantissa:1, trimMantissa:true};
            var aStr = numbro(a).format(formatOpts);
            var bStr = numbro(b).format(formatOpts);
            let label = t(property+'-progress-label', {a:aStr, b:bStr, percent});
            result.push({type:property, label:label, percent:percent});
        }
    }

    return result;
}



// WEBPACK FOOTER //
// ./src/modules/challenges/tools.js